import React from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'ramda';
import { withRenderFlag } from '@beef/react';
import { getFTTBFirewallService } from 'pages/Internet/store/selectors/firewallSelectors';

import PropTypes from 'prop-types';
import { FlexContainer, ServiceCardWrapper, ServiceGridItem } from '../../components';
import { FirewallFormConnected } from '../FirewallFormConnected';
import { FirewallCard } from './connected';
import { FirewallFutureRequestSuccessStatus, FirewallErrorConnected } from './containers';

const FirewallCardLayout = ({ isMobile }) => (
  <ServiceGridItem>
    <ServiceGridItem.Wrapper>
      <FirewallCard isMobile={isMobile}>
        <ServiceCardWrapper isMobile={isMobile}>
          <FlexContainer>
            <FirewallCard.Switch />
            <FirewallCard.Title />
          </FlexContainer>
        </ServiceCardWrapper>

        <FirewallCard.Additional isMobile={isMobile} />
        <FirewallCard.Price isMobile={isMobile} />
      </FirewallCard>

      <FirewallFormConnected />

      <>
        <FirewallFutureRequestSuccessStatus />
        <FirewallErrorConnected />
      </>
    </ServiceGridItem.Wrapper>
  </ServiceGridItem>
);

FirewallCardLayout.propTypes = {
  isMobile: PropTypes.bool,
};

export const FirewallCardConnected = connect(
  (state) => ({
    shouldRender: !isEmpty(getFTTBFirewallService(state)),
  }),
)(withRenderFlag(FirewallCardLayout));
